import {
  faCaretDown,
  faCaretUp,
  faMinus,
} from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { AnimatedNumber } from 'atoms/animations/AnimatedNumber';
import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';
import { fantasy } from 'lib/glossary';

type Props = { scoreDifference: number };
export const AnimatedLineupScoreDifference = ({ scoreDifference }: Props) => {
  const props = { icon: faMinus, color: 'var(--c-neutral-600)' };
  if (scoreDifference > 0) {
    props.icon = faCaretUp;
    props.color = 'var(--c-rivals-win)';
  } else if (scoreDifference < 0) {
    props.icon = faCaretDown;
    props.color = 'var(--c-rivals-loss)';
  }

  return (
    <Horizontal>
      <FontAwesomeIcon {...props} />
      <Horizontal gap={0.5}>
        <FormattedMessage
          {...fantasy.pointsWithoutFormat}
          values={{
            score: (
              <span style={{ fontWeight: 'bold' }}>
                <AnimatedNumber value={Math.abs(scoreDifference)} />
              </span>
            ),
          }}
        />
      </Horizontal>
    </Horizontal>
  );
};
